import { render, staticRenderFns } from "./StempelEdit.vue?vue&type=template&id=4785aaa2"
import script from "./StempelEdit.vue?vue&type=script&lang=ts"
export * from "./StempelEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports